var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './styles.module.css';
import { Tooltip } from '../../Components/BaseComponents/Tooltip';
var THRESHOLD_LENGTH_VALUE_FOR_USE_TOOLTIP = 21;
export var OrderValueWithTooltip = function (_a) {
    var value = _a.value;
    var orderValue = (_jsx("p", __assign({ className: "".concat(styles.table_content, " ").concat(styles.bold) }, { children: value })));
    return (_jsx(_Fragment, { children: value.length > THRESHOLD_LENGTH_VALUE_FOR_USE_TOOLTIP ? (_jsx(Tooltip, __assign({ content: value }, { children: orderValue }))) : (_jsx(_Fragment, { children: orderValue })) }));
};
